<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close()" [attr.aria-label]="t('commonActions.cancel')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="top-1">
		{{ t('billing.selectBilling') }}
	</h2>
	<mat-dialog-content>
		<div class="flex flex-col gap-2">
			@for (billing of data.billings; track billing.exportId) {
				<button
					type="button"
					(click)="selectBilling(billing)"
					class="billing-item flex flex-row items-center gap-3 p-3 border border-primary/30 rounded-lg bg-primary/5 cursor-pointer transition-all duration-200 hover:bg-primary/20 hover:border-primary/50 hover:shadow-md w-full text-left">
					<mat-icon class="text-primary flex-shrink-0">receipt_long</mat-icon>
					<div class="flex flex-col justify-start items-start leading-tight flex-1">
						<span class="text-base font-medium text-black">{{ billing.billingNumber }}</span>
						<span class="text-sm text-gray-600">{{ billing.billingName }}</span>
					</div>
				</button>
			}
		</div>
	</mat-dialog-content>
</div>
